import { db } from "../firebase-config";
import { collection, query, addDoc, onSnapshot, doc, updateDoc, deleteDoc, where } from "firebase/firestore";

// Add a new client
export const addClient = async (organization, client) => {
    try {
        await addDoc(collection(db, "organizations", organization, "customers"), {
            address: client.address,
            city: client.city,
            state: client.state,
            email: client.email,
            zip_code: client.zip_code,
            first_name: client.first_name,
            last_name: client.last_name,
            phone_number: client.phone_number,
            stripe_customer_id: "",
            deleted: false,
        });
        return { success: true, error: null };
    } catch (error) {
        console.error("Error adding client:", error);
        return { success: false, error: error.message || 'Failed to add client' };
    }
};

// Listener for organization customers
export const organizationCustomersSnapshotListener = (organization, onCustomerUpdate) => {
    const customerQuery = query(
        collection(db, "organizations", organization, "customers"),
        where("deleted", "!=", true)
    );
    const unsubscribe = onSnapshot(customerQuery, (querySnapshot) => {
        const customerItems = [];
        querySnapshot.forEach((doc) => {
          customerItems.push({ id: doc.id, ...doc.data() });
        });
        onCustomerUpdate(customerItems);
    })
    return () => unsubscribe()
}

// Update a client's information
export const updateClient = async (organization, id, clientData) => {
    try {
        const clientRef = doc(db, "organizations", organization, "customers", id);
        await updateDoc(clientRef, clientData);
        return { success: true, error: null };
    } catch (error) {
        console.error("Error updating client:", error);
        return { success: false, error: error.message || 'Failed to update client' };
    }
};

export const deleteClient = async (organization, clientId) => {
    try {
        const clientRef = doc(db, "organizations", organization, "customers", clientId);
        await updateDoc(clientRef, { deleted: true });
        return { success: true, error: null };
    } catch (error) {
        console.error("Error deleting client:", error);
        return { success: false, error: error.message || 'Failed to delete client' };
    }
};

// Listener for a single customer
export const customerSnapshotListener = (organization, id, onCustomerUpdate) => {
    const customerDocRef = doc(db, "organizations", organization, "customers", id);

    const unsubscribe = onSnapshot(customerDocRef, (docSnapshot) => {
        if (docSnapshot.exists()) {
            const data = docSnapshot.data();
            if (!data.deleted) {
                onCustomerUpdate({ id: docSnapshot.id, ...data });
            } else {
                onCustomerUpdate(null);
            }
        } else {
            onCustomerUpdate(null);
        }
    });
    return unsubscribe;
};
